import { atomWithStorage } from "jotai/utils";

export const dealerActiveAuctionSearchTermsAtom = atomWithStorage<string>(
  "dealerActiveAuctionSearchTermsAtom",
  "",
  undefined,
  { getOnInit: true }
);
